export const getHiddenColumns = (tableId: string): string[] => {
  if (!tableId) return [];
  const stateJson = localStorage.getItem('table_' + tableId);
  if (!stateJson) return [];
  const state = JSON.parse(stateJson);
  return state;
};

export const getInitialHiddenColumnsByUser = (
  key: string,
): {
  hiddenColumns: string[];
  stickyColumns: string[];
  columnWidths: any;
  sortBy: Array<{ id: string; desc?: boolean }>;
} => {
  const fallback = { hiddenColumns: [], stickyColumns: [], columnWidths: [], sortBy: [] };
  const storedData = localStorage.getItem(key);
  try {
    // sortBy is only present for tables opted into persistSort; default it so older blobs stay valid.
    return { ...fallback, ...(JSON.parse(storedData) || {}) };
  } catch (error) {
    console.error('Error parsing localStorage data:', error);
    return fallback; // Fallback to default if parsing fails
  }
};
